// Function loadWoolLabMyMoodboardsBlock loads the WoolLabMyMoodboardsBlock class by dynamically importing the js on demand if needed

export function loadWoolLabMyMoodboardsBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-fabric-swatch-favourites-block-chunk" */ '../widgets/woolLabMyMoodboardsBlock').then(wg => {

		const { WoolLabMyMoodboardsBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="WoolLabMyMoodboardsBlock"]');

		if(!$wg) {
			// console.info('WoolLabMyMoodboardsBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="WoolLabMyMoodboardsBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new WoolLabMyMoodboardsBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new WoolLabMyMoodboardsBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the WoolLabMyMoodboardsBlock widget');

}
